import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./index.scss";

const steps = [
  {
    number: "01",
    title: "ANALYSE & DIAGNOSTIC",
    description: "Diagnostic approfondi de votre situation",
  },
  {
    number: "02",
    title: "STRATÉGIE & CONCEPTION",
    description: "Élaboration d’une stratégie",
  },
  {
    number: "03",
    title: "DÉPLOIEMENT & OPTIMISATION",
    description: "Mise en œuvre optimisée avec suivi continu",
  },
];

const WorkProcess = () => {
  return ( 
    <section className="work-process-section py-5 d-md-block d-none">
      <div className="text-center work-process-container">
        <h2 className="section-title">Comment Nous Travaillons</h2>
        <p className="section-subtitle mb-5">
         Notre méthode éprouvée, pensée pour transformer <br/>vos idées en résultats mesurables.
        </p>

        <Row className="justify-content-center position-relative step-container">
          {steps.map((step, index) => (
            <Col md={4} sm={12} key={index} className="step-item">
              <div className="step-number">{step.number}</div>
              <div className="step-line"></div>
              <h5 className="step-title mt-3">{step.title}</h5>
              <p className="step-description">{step.description}</p>
            </Col>
          ))}

          {/* Ligne de liaison horizontale */}
          <div className="step-connector d-none d-md-block"></div>
        </Row>
      </div>
    </section>
  );
};

export default WorkProcess;
